function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 18.333a8.333 8.333 0 110-16.666 8.333 8.333 0 010 16.666zm0-1.666a6.667 6.667 0 100-13.334 6.667 6.667 0 000 13.334zm-.752-1.774c.198.171.429.257.693.257a.988.988 0 00.677-.26c.196-.174.293-.413.293-.717a.938.938 0 00-.28-.69.938.938 0 00-.69-.28.968.968 0 00-.703.28.927.927 0 00-.286.69c0 .308.099.548.296.72zM7.161 6.76c-.264.423-.397.841-.397 1.253 0 .2.084.386.251.557a.826.826 0 00.615.257c.413 0 .692-.245.84-.736.156-.468.347-.823.573-1.064.226-.24.577-.361 1.055-.361.408 0 .74.119.999.358.258.238.387.531.387.879a1 1 0 01-.127.494c-.084.152-.188.29-.312.414s-.325.307-.602.55c-.317.278-.569.518-.755.72a2.405 2.405 0 00-.45.702c-.113.268-.169.583-.169.948 0 .29.077.51.231.657a.792.792 0 00.57.222c.434 0 .692-.226.775-.677.047-.213.083-.362.107-.446a1.37 1.37 0 01.1-.254c.044-.085.11-.178.2-.28.088-.102.207-.22.354-.355.534-.478.904-.817 1.11-1.019a2.97 2.97 0 00.534-.72c.15-.277.225-.6.225-.97 0-.468-.132-.902-.394-1.301-.263-.4-.635-.716-1.117-.948-.481-.232-1.037-.348-1.666-.348-.677 0-1.27.139-1.778.417-.507.277-.894.628-1.159 1.051z"
});

var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20"
  }), _ref);
};

export default SvgHelp;